import { makeAutoObservable } from "mobx";
import type { TProjectMembership } from "@/types/project";

export interface IProjectMemberFilters {
  search: string;
  role: "all" | "admin" | "member" | "guest";
}

/**
 * The members settings page's filters: UI state only. The roster itself is
 * read through the shared cache (`useProjectMembers`, R9, NG-2795).
 */
export class ProjectMembersStore {
  filters: IProjectMemberFilters = {
    search: "",
    role: "all",
  };

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setFilter<K extends keyof IProjectMemberFilters>(key: K, value: IProjectMemberFilters[K]): void {
    this.filters[key] = value;
  }

  /** The members that match the filters. */
  filter(members: readonly TProjectMembership[]): TProjectMembership[] {
    const search = this.filters.search.trim().toLowerCase();
    return members.filter((member) => {
      const detail = member.member_detail;
      const matchesSearch =
        search.length === 0 ||
        detail?.display_name.toLowerCase().includes(search) ||
        detail?.email?.toLowerCase().includes(search);

      if (!matchesSearch) return false;

      if (this.filters.role === "all") return true;
      if (this.filters.role === "admin") return member.role === "project.lead";
      if (this.filters.role === "member") return member.role === "project.member";
      return false;
    });
  }
}
